export const ReleaseInfo = Object.freeze({
  releaseVersion: '2026.3.19-1706.31',
  commitId: '7816cde3453ec5029e4923977209693b1e9b060e',
  commitTime: '2026-03-19T17:06:31.000Z',
});
